import { useSelector } from 'react-redux';

import { Routes } from '@/constants';
import { Link } from '@/containers';
import { EVENT_CONSTANTS } from '@/services';
import {
  selectIsAdminUser,
  selectPlan,
  selectSessionUserId,
  selectUserCompliance,
  useFetchOrganizationPlaylistEpisodesQuery,
} from '@/store';

import {
  EpisodeCardCarousel,
  EpisodeCardCarouselEmptyPlaceholder,
} from '../EpisodeCardCarousel';

export const OrganizationPlaylistCarousel = () => {
  const compliance = useSelector(selectUserCompliance);
  const userId = useSelector(selectSessionUserId);
  const userPlan = useSelector(selectPlan);
  const isAdminUser = useSelector(selectIsAdminUser);

  const {
    data: episodes = [],
    isLoading,
    isUninitialized,
    isError,
  } = useFetchOrganizationPlaylistEpisodesQuery(
    { compliance },
    { skip: !userId },
  );

  const title = `Recommended By ${userPlan?.data?.organizationName || ''}`;

  if (isUninitialized || isError) return;

  return (
    <>
      {(isLoading || episodes?.length > 0) && (
        <EpisodeCardCarousel
          title={title}
          uKey="Recommended By"
          episodes={episodes}
          isLoading={isLoading}
          referrer={{
            page: EVENT_CONSTANTS.PAGE.DISCOVER,
          }}
          ViewAllLink={
            isAdminUser ? () => <ManageRecommendationsLink /> : undefined
          }
          sortCompletedEpisodesLast={true}
        />
      )}
      {!isLoading && episodes.length === 0 && isAdminUser && (
        <EpisodeCardCarouselEmptyPlaceholder
          title={title}
          Link={ManageRecommendationsLink}
        />
      )}
    </>
  );
};

const ManageRecommendationsLink = () => (
  <Link to={Routes.ADMIN_CONTENT}>Manage Recommendations</Link>
);
